/// <reference path="../../Common/Base/SiteEntityGrid.ts" />

namespace Matrix.Data {
    
    @Serenity.Decorators.registerClass()
    export class PartyRoleGrid extends SiteEntityGrid<PartyRoleRow, any> {
        protected getColumnsKey() { return 'Data.PartyRole'; }
        protected getDialogType() { return PartyRoleDialog; }
        protected getIdProperty() { return PartyRoleRow.idProperty; }
        protected getLocalTextPrefix() { return PartyRoleRow.localTextPrefix; }
        protected getService() { return PartyRoleService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}